import { createSlice } from '@reduxjs/toolkit';

import { getDefaultDate } from '../../utils/date';
import { updateChannelLLMSettings } from '../channels/actions';
import { ChannelType } from '../channels/types';
import { updateLLMSettings } from './actions';
import { LLM_SETTINGS_SLICE_NAME } from './constants';
import type { LLMSettingsType } from './types';

// TODO: put a more reasonable default id for the model
const DEFAULT_MODEL_ID = '';

const initialState = {
  modelId: DEFAULT_MODEL_ID,
  updatedAt: '',
  updatedBy: '',
} satisfies LLMSettingsType;

const slice = createSlice({
  name: LLM_SETTINGS_SLICE_NAME,
  initialState,
  reducers: {},
  // all reducers are here because actions are defined externally
  extraReducers: builder => {
    // main reducer to update llm settings
    builder.addCase(updateLLMSettings, (state, action) => {
      state.modelId = action.payload.modelId;
      state.updatedAt = getDefaultDate();
    });

    // Voice channel -> LLM settings sync
    builder.addCase(updateChannelLLMSettings, (state, action) => {
      const { channelType, llmSettings } = action.payload;
      if (channelType === ChannelType.VOICE && llmSettings) {
        state.modelId = llmSettings.modelId;
        state.updatedAt = getDefaultDate();
      }
    });
  },
});

export default slice.reducer;
